<template>
  <div class="work-order">
    <a-row :gutter="16" style="height: 100%">
      <!-- 左侧栏 -->
      <a-col :span="6" style="height: 100%">
        <a-row :gutter="16" style="height: 40%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('客户满意度')">
              <SatisfactionLevel />
            </DataContainer>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="height: 60%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('工单业务趋势')">
              <WorkOrderBusinessTrends />
            </DataContainer>
          </a-col>
        </a-row>
      </a-col>

      <!-- 中间栏 -->
      <a-col :span="12" style="height: 100%">
        <a-row :gutter="16" style="height: 50%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('工单基本指标')">
              <WorkOrderCenter />
            </DataContainer>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="height: 50%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('实时工单数据')">
              <WorkOrderRealTime />
            </DataContainer>
          </a-col>
        </a-row>
      </a-col>

      <!-- 右侧栏 -->
      <a-col :span="6" style="height: 100%">
        <a-row :gutter="16" style="height: 32%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('本月工单处理进度')">
              <WorkOrderProcessingProgress />
            </DataContainer>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="height: 34%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('工单构成分析')">
              <WorkOrderConstitute />
            </DataContainer>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="height: 34%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('工单来源分析')">
              <WorkOrderSource />
            </DataContainer>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import DataContainer from './DataContainer.vue'
import WorkOrderCenter from './modules/workorder/WorkOrderCenter.vue'
import WorkOrderRealTime from './modules/workorder/WorkOrderRealTime.vue'
import WorkOrderProcessingProgress from './modules/workorder/WorkOrderProcessingProgress.vue'
import WorkOrderConstitute from './modules/workorder/WorkOrderConstitute.vue'
import WorkOrderSource from './modules/workorder/WorkOrderSource.vue'
import SatisfactionLevel from './modules/workorder/SatisfactionLevel.vue'
import WorkOrderBusinessTrends from './modules/workorder/WorkOrderBusinessTrends.vue'

export default {
  name: 'WorkOrder',
  components: {
    DataContainer,
    WorkOrderCenter,
    WorkOrderRealTime,
    WorkOrderProcessingProgress,
    WorkOrderConstitute,
    WorkOrderSource,
    SatisfactionLevel,
    WorkOrderBusinessTrends
  },
  props: {
    // 可以添加一些props
  },
  data() {
    return {
      // 可以添加一些数据属性
    }
  },
  methods: {
    // 可以添加一些方法
  },
  mounted() {
    // 可以在这里执行一些初始化操作
    console.log('WorkOrder component mounted')
  }
}
</script>

<style lang="less" scoped>
.work-order {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// 响应式样式
@media (max-width: 1920px) {
  :deep(.ant-col-6) {
    flex: 0 0 25%;
    max-width: 25%;
  }
  
  :deep(.ant-col-12) {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (max-width: 1600px) {
  :deep(.ant-col-6) {
    flex: 0 0 30%;
    max-width: 30%;
  }
  
  :deep(.ant-col-12) {
    flex: 0 0 40%;
    max-width: 40%;
  }
}

@media (max-width: 1200px) {
  :deep(.ant-row) {
    flex-direction: column;
  }
  
  :deep(.ant-col-6),
  :deep(.ant-col-12) {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 10px;
  }
  
  :deep(.ant-row) {
    height: auto !important;
  }
  
  :deep(.ant-col-24) {
    height: 300px !important;
    margin-bottom: 10px;
  }
}

@media (max-width: 768px) {
  :deep(.ant-col-24) {
    height: 250px !important;
  }
  
  :deep(.DataContainer) {
    margin-bottom: 8px;
  }
}
</style>